import { Box, Grid2, Typography } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CurriculumCard from '../../shared/components/EducationForLife/CurriculumCard'
import { EducationForLifeImages } from '../../assets/img/educationforlife/EducationForLifeImages'
import CustomDivider from '../../shared/utils/CustomDivider'

const ValueEditionOfElyfSection = ({ valueEditionElyfData }) => {
    const data = [
        {
            iconImage: EducationForLifeImages.ColorPalleteIcon,
            title: "Customized Learning Material",
            content: "Designed specifically for age and grade—not generic worksheets.",
            bgColor: "#36BBE4"
        },
        {
            iconImage: EducationForLifeImages.PeoplesIcon,
            title: "Concept-Based, Not Chapter-Based",
            content: "We teach what every child must know for life, not just what’s in the textbook.",
            bgColor: "#FD2F7B"
        },
        {
            iconImage: EducationForLifeImages.BulbIcon,
            title: "Real-Life Application",
            content: "Activities connect learning to real situations—shopping math, reading signs, writing messages, etc.",
            bgColor: "#E47C36"
        },
        {
            iconImage: EducationForLifeImages.HandShakeIcon,
            title: "Tracking & Assessment",
            content: "Regular evaluations help parents understand progress and areas to improve.",
            bgColor: "#9954E2"
        },
    ]
    return (
        <Box>
            <Heading Heading={valueEditionElyfData?.heading} />
            <Grid2 container spacing={"1rem"}>
                <Grid2 children size={{ xs: 12, sm: 12, md: 4 }}>
                    <Typography variant='body1' color="grey.400" fontWeight={300} dangerouslySetInnerHTML={{ __html: valueEditionElyfData?.description }} />
                    {/* The ELYF Curriculum brings meaningful value to every learning stage by combining structured academic progression, hands-on exploration, and holistic growth, ensuring students develop not just knowledge, but confidence, creativity, and essential life skills.
                    </Typography> */}
                    <CustomDivider size={"1rem"} />

                </Grid2>
                <Grid2 container size={{ xs: 12, sm: 12, md: 8 }} spacing={"1rem"}>
                    {
                      valueEditionElyfData?.curriculumList?.map((item, index) => (
                            <Grid2 children size={{ xs: 12, sm: 12, md: 6 }} key={index} sx={{ display: "flex", alignItems: "stretch" }}>
                                <CurriculumCard item={item} />
                            </Grid2>
                        ))
                    }
                </Grid2>
            </Grid2>
        </Box>
    )
}

export default ValueEditionOfElyfSection
